var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkedin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 0H1.71C.797 0 0 .656 0 1.558v16.728C0 19.192.797 20 1.709 20h16.686c.918 0 1.605-.813 1.605-1.714V1.558C20.005.656 19.312 0 18.4 0ZM6.2 16.671H3.334V7.762H6.2v8.909ZM4.866 6.408h-.02c-.917 0-1.511-.683-1.511-1.537 0-.87.61-1.537 1.547-1.537.937 0 1.51.662 1.531 1.537 0 .854-.594 1.537-1.547 1.537Zm11.805 10.263h-2.865V11.8c0-1.167-.417-1.964-1.454-1.964-.792 0-1.26.535-1.469 1.057-.078.188-.1.443-.1.704v5.074H7.92V7.762h2.865v1.24c.417-.594 1.068-1.448 2.584-1.448 1.88 0 3.303 1.24 3.303 3.912v5.205Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/linkedin.361d45d4fca3b4c719c1f579211ad8c6.svg";